"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TokenList_1 = __importDefault(require("../../utils/dom/TokenList"));
const createId_1 = require("../../utils/react/createId");
const variables_1 = require("../../variables");
require("./MainTitle.css");
exports.default = react_1.default.memo(function MainTitle(props) {
    return (react_1.default.createElement("h1", { id: (0, createId_1.createId)(props), ...props, className: TokenList_1.default.join([variables_1.StyleNamespace, 'MainTitle', props.className]) }));
});
